import type { ClientFrame, ServerFrame } from "../shared/protocol";

export type SocketHandlers = {
  onFrame: (frame: ServerFrame) => void;
  onStatus: (status: "connecting" | "open" | "closed" | "reconnecting") => void;
};

export function connectRoom(path: string, handlers: SocketHandlers) {
  let ws: WebSocket | null = null;
  let closed = false;
  let attempt = 0;
  let since: string | null = null;

  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  const url = `${proto}//${location.host}/ws${path}`;

  const open = () => {
    if (closed) return;
    handlers.onStatus(attempt === 0 ? "connecting" : "reconnecting");
    ws = new WebSocket(url);
    ws.addEventListener("open", () => {
      attempt = 0;
      handlers.onStatus("open");
    });
    ws.addEventListener("message", (ev) => {
      try {
        const frame = JSON.parse(String(ev.data)) as ServerFrame;
        if (frame.type === "message") since = frame.message.createdAt;
        handlers.onFrame(frame);
      } catch {
        /* ignore */
      }
    });
    ws.addEventListener("close", () => {
      handlers.onStatus("closed");
      if (closed) return;
      attempt += 1;
      const wait = Math.min(12_000, 400 * 2 ** attempt) + Math.random() * 400;
      setTimeout(open, wait);
    });
    ws.addEventListener("error", () => ws?.close());
  };

  open();

  return {
    send(frame: ClientFrame) {
      if (ws && ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify(frame));
    },
    close() {
      closed = true;
      ws?.close();
    },
    since() {
      return since;
    },
  };
}
